module.exports = __webpack_public_path__ + "static/img/banner_9.ee133a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carousel/banner_9.jpg
// module id = 4hxO
// module chunks = 0